import { addRovoParamsToUrl } from '@atlassian/conversation-assistant-pubsub';

import { ATLAS_BASE_URL } from '../../constants/private';

export const getAtlasURL = (cloudId: string, path: string) => {
	let argConcat = '?';
	let processedPath = path.startsWith('/') ? path : `/${path}`;

	if (processedPath.includes('?')) {
		argConcat = '&';
	}

	return addRovoParamsToUrl(`${ATLAS_BASE_URL}${processedPath}${argConcat}cloudId=${cloudId}`, {
		cloudId,
	});
};
